module.exports = __webpack_public_path__ + "img/pc.2d98ca6c.jpg";